import { styled } from "goober";

const Outer = styled("div")``;

const Inner = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 0.1s ease-out;
`;

const InnerWithHover = styled(Inner)`
  background-color: var(--alpha4);

  &:hover {
    background-color: var(--alpha8);
  }
`;

const InnerWithSubtleHover = styled(Inner)`
  &:hover {
    background-color: var(--alpha4);
  }
`;

type Props = {
  size: number;
  children: React.ReactNode;
  hover?: boolean;
  borderRadius?: number;
  outline?: boolean;
  outlineWidth?: number;
  hoverBackground?: boolean;
  subtleHover?: boolean;
  background?: boolean;
};

export function ConnectorLogoContainer({
  size,
  children,
  hover,
  borderRadius = 12,
  outline = true,
  outlineWidth = 1,
  hoverBackground = true,
  subtleHover = false,
  background = true,
}: Props) {
  const InnerComponent = subtleHover
    ? InnerWithSubtleHover
    : hoverBackground
      ? InnerWithHover
      : Inner;
  return (
    <Outer
      style={{
        borderRadius,
        backgroundColor: outline
          ? "var(--cell-bg, var(--surface-primary))"
          : undefined,
        outline: outline
          ? `${outlineWidth}px solid var(--cell-bg, var(--surface-primary))`
          : undefined,
      }}
    >
      <InnerComponent
        style={{
          width: size,
          height: size,
          borderRadius,
          transform: hover ? "scale(1.08)" : "scale(1)",
          backgroundColor:
            background && !hoverBackground && !subtleHover
              ? "var(--alpha4)"
              : undefined,
        }}
      >
        {children}
      </InnerComponent>
    </Outer>
  );
}
